﻿import {IDisposableLike} from "./IDisposableLike";

/**
 * Crée une pile de ressources disposables.
 */
export class DisposableStack {
    #stack : IDisposableLike[] = [];
    public Disposed = false;

    /**
     * Ajoute une ressource à la pile.
     * @param ressource ressource ajoutée à la pile.
     * @return la ressource.
     */
    public Use<T extends IDisposableLike>(ressource : T) : T {
        if (this.Disposed)
            throw new Error("La resource disposed");
        
        this.#stack.push(ressource);
        return ressource;
    }
    
    public Reset = () => {
        this.#stack.length = 0;
        this.Disposed = false;
    }

    /**
     * Ajoute une ressource qui sera appelée lors de la suppression de la pile.
     * @param cleanup Méthode executée lors de la suppression de la pile.
     */
    public Defer = (cleanup: () => void) => 
        this.Use({Dispose: cleanup});

    /**
     * Dispose chaque ressource de la pile dans l'ordre inverse.
     */
    public Dispose = () => {
        if (this.Disposed)
            return;
        
        this.Disposed = true;
        for (let i = this.#stack.length - 1; i >= 0; i--) {
            try { this.#stack[i].Dispose(); } catch { /* best-effort */ }
        }
        this.#stack.length = 0;
    }
}